'use client';

import { ReactElement } from 'react';
import * as ToolTip from '@radix-ui/react-tooltip';
import { Text } from '../Text';
import styles from './tooltip.module.sass';

interface ITooltip {
    /**
     * An element tooltip will be assigned to
     */
    icon: ReactElement;
    text: string;
}

/**
 * A popup that displays information related to an element when the element receives keyboard focus or the mouse
 * hovers over it.
 * https://www.radix-ui.com/primitives/docs/components/tooltip
 */
const Tooltip = ({ icon, text }: ITooltip) => {
    return (
        <ToolTip.Provider delayDuration={400}>
            <ToolTip.Root>
                <ToolTip.Trigger asChild>
                    <span className={styles.icon}>{icon}</span>
                </ToolTip.Trigger>
                <ToolTip.Portal>
                    <ToolTip.Content className={styles.tooltipContent} sideOffset={5}>
                        <Text
                            color="dark"
                            as="p"
                            size={{
                                default: '12',
                                md: '12',
                            }}
                            variant="text1"
                        >
                            {text}
                        </Text>
                        <ToolTip.Arrow className={styles.tooltipArrow} asChild>
                            <svg
                                width="10"
                                height="5"
                                viewBox="0 0 30 10"
                                preserveAspectRatio="none"
                                style={{ display: 'block' }}
                            >
                                <polygon points="0,0 30,0 15,10"></polygon>
                            </svg>
                        </ToolTip.Arrow>
                    </ToolTip.Content>
                </ToolTip.Portal>
            </ToolTip.Root>
        </ToolTip.Provider>
    );
};

export { Tooltip };
